import { Component, OnInit } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpHeaders } from "@angular/common/http";
import { environment } from "../../../environments/environment";
import { User } from "../../_models/user";
import { Router, ActivatedRoute } from "@angular/router";
import { Globals } from "../../_models/globals";
import { AlertService } from '../../_services/alert.service';
import * as moment from 'moment';
import { ApiIntegration } from '../../_services/api.integration';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
//import { LocalStorageService, SessionStorageService, LocalStorage, SessionStorage } from 'angular-web-storage';

@Component({
  selector: 'app-opencart-user-create',
  templateUrl: './opencart-user-create.component.html',
  styleUrls: ['./opencart-user-create.component.scss'],
})
export class OpencartUserCreateComponent implements OnInit {
  productImage: string = "/assets/images/default-product.png";
  apiKey: string;
  apiKeyError: string;
  hostNamePrefix: string;
  selectedId: string;
  storeURLError: string;
  storeURL: string;
  statusText22: string;
  channelName: string;
  imageUrl: string;
  uploadImage: string;
  disableStatuses = true;
  userNameError: string;
  storeId: any;
  errorMessage: string;
  instructions: string = 'N';

  constructor(private alertService: AlertService, private api: ApiIntegration, private user: User, private http: HttpClient, private router: Router, private route: ActivatedRoute, public g: Globals) {
    this.g.page = "Create Store Management";
    this.hostNamePrefix = "https://";
    this.selectedId = this.route.snapshot.params['id']
  }

  storeURLBlur() {
    this.storeURLError = "";
    if (!this.storeURL) {
      this.storeURLError = 'Please enter store URL';
    }
  }

  apiKeyBlur() {
    this.apiKeyError = "";
    if (!this.apiKey) {
      this.apiKeyError = 'Please enter Secret key ';
    }
  }

  ngOnInit() {
  }

  typechannelName() {
    this.statusText22 = "";
    if (this.channelName == '' || this.channelName === null || this.channelName === undefined || this.channelName === 'undefined') {
      this.statusText22 = 'Please enter Channel Name';
    }
  }

  submit() {
    this.g.loaderDisplay = "display";
    var header1 = new HttpHeaders();
    header1 = header1.append('Content-Type', 'application/json');
    header1 = header1.append('Accept', 'application/json');
    header1 = header1.append('Authorization', 'Bearer ' + localStorage.getItem('jwt'));
    this.http.post(environment.apiUrl + 'api/toStoreMagentoCredentials', {
      "accountOwnerId": this.user.accountOwnerId,
      "connectionName": this.channelName,
      "hostName": this.hostNamePrefix + this.storeURL,
      "apiKey": this.apiKey,
      "organizationId": 1,
      "storeType": "OPENCART",
      "brandImageUrl": this.imageUrl,
      "storeId": this.storeId
    },
      { headers: header1 }).subscribe(data => {
        this.g.loaderDisplay = "";
        if (data['code'] == 200) {
          this.alertService.success('Open Cart', 'Submitted Successfully');
          this.storeId = data['storeId'];
          this.disableStatuses = false;
          this.router.navigate(['/admin/storeIntegrations']);
        } else {
          this.alertService.error('Error', data['message']);
        }
      },
        (err: HttpErrorResponse) => {
          this.g.loaderDisplay = "";
        });
  }


  verify() {
    this.g.loaderDisplay = "display";
    this.storeURLError = "";
    this.apiKeyError = "";
    this.userNameError = "";
    this.statusText22 = "";

    if (this.channelName == '' || this.channelName === null || this.channelName === undefined || this.channelName === 'undefined') {
      this.statusText22 = 'Please enter Channel Name';
    }
    if (!this.storeURL) {
      this.storeURLError = 'Please enter store Url';
    }
    if (!this.apiKey) {
      this.apiKeyError = 'Please enter Secret key';
    }
    if (this.statusText22 != "" || this.storeURLError != "" || this.apiKeyError != "") {
      this.g.loaderDisplay = "";
      return false;
    }
    var header1 = new HttpHeaders();
    header1 = header1.append('Content-Type', 'application/json');
    header1 = header1.append('Accept', 'application/json');
    header1 = header1.append('Authorization', 'Bearer ' + localStorage.getItem('jwt'));
    this.http.post(environment.apiUrl + 'api/verifyOpenCartConnection', {
      "accountOwnerId": this.user.accountOwnerId,
      "connectionName": "OPENCART",
      "organizationId": this.user.organizationId,
      "secretKey": this.apiKey,
      "storeUrl": this.hostNamePrefix + this.storeURL
    },
      { headers: header1 }).subscribe(data => {
        this.g.loaderDisplay = "";
        if (data['code'] == 200) {
          this.alertService.success('Open Cart', 'Connected Successfully');
          this.submit();
        } else {
          this.alertService.error('Error', data['message']);
        }
      },
        (err: HttpErrorResponse) => {
          this.g.loaderDisplay = "";
        });
  }

  showInstructions() {
    this.instructions = 'Y';
  }

  loadImage(event) {
    this.productImage = URL.createObjectURL(event.target.files[0]);
    this.uploadImage = event.target.files[0];
    this.errorMessage = "";
    this.submitImage();
  }

  ignoreImage() {
    this.productImage = "/assets/images/default-product.png";
    this.uploadImage = null;
    this.imageUrl = null;
    this.errorMessage = "";
  }

  submitImage() {
    this.g.loaderDisplay = "display";
    const file = this.uploadImage;
    const formData: FormData = new FormData();
    formData.append('file', file);
    var headerObj = new HttpHeaders();
    //headerObj = headerObj.append('content-Type', 'multipart/form-data');
    headerObj = headerObj.append('Authorization', 'Bearer ' + localStorage.getItem('jwt'));
    this.http.post(environment.apiUrl + 'api/uploadImageToS3', formData, { headers: headerObj }).subscribe(data => {
      this.g.loaderDisplay = "";
      if (data['code'] == 200) {
        this.imageUrl = data['message'];
      } else {
        this.imageUrl = "";
      }
    },
      (err: HttpErrorResponse) => {
        this.g.loaderDisplay = "";
        this.errorMessage = "Upload Image Failed Please Re-try";
      });
  }
}
